import { useState } from 'react';

export function useTranslate() {
    const [state] = useState({
        'button.save': 'Save',
        'button.next': 'Next',
        'order_page.sequence_nr': 'Order Nr:',
        'order_page.payment_required': 'Payment required!',
        'order_page.placed': 'We have received your order!',
        'order_page.in_preparation': 'Your order is being prepared!',
        'order_page.DELIVERY.ready': 'Your order is ready!<br/>We will bring it to you ASAP',
        'order_page.PICKUP.ready': 'Your order is ready!<br/>Come and pick up the following products:',
        'order_page.delivered': 'All products have been delivered!<br/>Bon Appétit!',
        'order_page.cancelled': 'Your order has been cancelled!',
        'order_page.total_cost': 'Total:',
        'order_page.products_ready': 'Products ready:',
        'order_page.button_details': 'Show details',
        'order_page.drawer_details.title': 'Details',
        'order_page.contact.title': 'How to contact you?',
        'order_page.contact.description':
            'Please enter your phone number so we can let you know when your order is ready',
        'order_page.contact.additional_info':
            'NB! If you decide not to enter you phone, <b>please check this screen from time to time</b> to get updates about your order',
        'covid_reg.description':
            'Due to COVID-19 related circumstances, you are required to provide valid contact information about yourself.',
    });

    return {
        t(message: string, params?: any) {
            return state[message] ?? message;
        },
    };
}
